import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FileSpreadsheet, FileText } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// 経理提出用：入金月を選んで入金済み請求書のCSV/PDFをダウンロード
export const PaidInvoicesExport = ({ getAuthHeaders }) => {
  const now = new Date();
  const [month, setMonth] = useState(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`);
  const [loading, setLoading] = useState('');
  const download = async (kind) => {
    if (!month) return;
    setLoading(kind);
    try {
      const path = kind === 'pdf' ? 'paid-export/pdf' : 'paid-export';
      const res = await axios.get(`${API}/admin/invoices/${path}`, { params: { month }, headers: getAuthHeaders(), responseType: 'blob' });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `入金済み請求書_${month}.${kind}`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error('ダウンロードに失敗しました');
    } finally {
      setLoading('');
    }
  };
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2 rounded-md border border-[#00A651]/30 bg-[#f2fbf6] px-3 py-2 text-sm" data-testid="paid-invoices-export">
      <span className="font-medium text-gray-700">経理用：入金済み請求書の一覧</span>
      <span className="text-gray-500">入金月</span>
      <Input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="w-[160px] h-8 bg-white" data-testid="paid-export-month" />
      <Button size="sm" onClick={() => download('csv')} disabled={!!loading || !month} className="bg-[#00A651] hover:bg-[#008a43]" data-testid="paid-export-download-btn">
        <FileSpreadsheet className="h-4 w-4 mr-1" />{loading === 'csv' ? '作成中…' : 'CSVダウンロード'}
      </Button>
      <Button size="sm" variant="outline" onClick={() => download('pdf')} disabled={!!loading || !month} className="border-[#00A651] text-[#00A651] hover:bg-[#e8f5e9]" data-testid="paid-export-pdf-btn">
        <FileText className="h-4 w-4 mr-1" />{loading === 'pdf' ? '作成中…' : 'PDFダウンロード'}
      </Button>
      <span className="text-[11px] text-gray-500">CSVはExcel用／PDFは印刷・提出用（合計・支払方法ごとの小計付き）</span>
    </div>
  );
};

export default PaidInvoicesExport;
